// Vendors
import $ from 'jquery';
import globalLoader from './global-loader';
import highlighter from 'keyword-highlighter';
import { scrollToElement } from '../lib/utilities';

// Loading
$(() => {
  if (typeof FWP === 'object') {
    FWP.loading_handler = (params) => {
      globalLoader.show();
      params.element.css('opacity', 0.5).css('pointer-events', 'none');

      $(document).on('facetwp-loaded', () => {
        globalLoader.hide();
        params.element.css('opacity', 1).css('pointer-events', 'auto');
      });
    };
  }
});

// Scroll
$(document).on('facetwp-loaded', function () {
  if (FWP.loaded) {
    const allPosts = $('.facetwp-template').children().children().get();
    const newPost =
      allPosts[
        FWP.settings.pager.page * FWP.settings.pager.per_page -
          FWP.settings.pager.per_page
      ];

    if (newPost) {
      scrollToElement(newPost);
    } else if (FWP.facet_type.load_more !== 'pager') {
      scrollToElement($('.facetwp-template'));
    }
  }
});

$(document).on('facetwp-loaded', () => {
  const dropDownAlt = document.getElementById('tag-dropdown');

  if (!dropDownAlt) return;

  // set refresh to true so sorting filters still take affect
  FWP.auto_refresh = true;

  dropDownAlt.addEventListener('change', (e) => {
    e.preventDefault();

    // set to false to prevent redirect loop
    FWP.auto_refresh = false;

    const { value } = dropDownAlt.options[dropDownAlt.selectedIndex].dataset;

    // send window to articles tag
    if (value) window.location.href = '/newsroom/articles/' + value;
  });
});

// Create a button for manually submitting FacetWP search
$('[data="facetwp-search"]').on('click', () => {
  FWP.refresh();
});

// Highlight
$(document).on('facetwp-loaded', () => {
  const terms = FWP.facets['search'];
  if (typeof terms !== 'string') return;

  const elementsToHighlight = $('.facetwp-template .search-hit').find(
    '.search-hit__title, .search-hit__description'
  );
  elementsToHighlight.each((index, elem) => {
    const highlightedText = highlighter(terms, $(elem).text());
    $(elem).html(highlightedText);
  });
});

// Dispatch custom vanilla JS events for each FWP jQuery event
let facetWPLoadCount = 1;

$(document).on('facetwp-loaded', () => {
  const options = {
    detail: { facetWPLoadCount }
  };

  if (facetWPLoadCount < 2)
    document.dispatchEvent(new CustomEvent('facetWPLoaded', options));

  if (facetWPLoadCount > 1) {
    document.dispatchEvent(new CustomEvent('facetWPUpdated', options));
  }

  facetWPLoadCount++;
});

$(document).on('facetwp-refresh', () => {
  document.dispatchEvent(new CustomEvent('facetWPRefresh'));
});
